import { API_ROUTE_SHOP_ORDER_AUDIT_LOG } from '@/api/apiRoutes'
import { get } from '@/util/auth'

type UserOriginal = {
  id: number
  customerId: number
  username: string
  firstName: string
  lastName: string
}

type AuditLogItemOriginal = {
  id: number
  orderId: number
  timestamp: string
  action: string
  userId: number
  costObjectId: number
  user: UserOriginal | null
}

const IS_NEW_BACKEND_API = true

export const shopOrderResources = {
  getAuditLog: async (orderId: number) =>
    get<AuditLogItemOriginal[]>(
      API_ROUTE_SHOP_ORDER_AUDIT_LOG.replace(':orderId', String(orderId)),
      IS_NEW_BACKEND_API
    ),
}
